import React from 'react';
import { FailedSendCreditTasksTable } from './FailedSendCreditTasksTable';

export const FailedSendCreditTasksList: React.FC = () => {
  return <FailedSendCreditTasksTable />;
};
